import React from 'react';
import Cartao from '../../Componentes/Card/Card';
import './Eventos.css';



function Eventos(){
  return( <Cartao></Cartao>
    
)
 
  
};

export default Eventos;
